import { render, staticRenderFns } from "./CompanyLegalPanel.vue?vue&type=template&id=dc4ee612&scoped=true"
import script from "./CompanyLegalPanel.vue?vue&type=script&lang=js"
export * from "./CompanyLegalPanel.vue?vue&type=script&lang=js"
import style0 from "./CompanyLegalPanel.vue?vue&type=style&index=0&id=dc4ee612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ee612",
  null
  
)

export default component.exports